module.exports = __webpack_public_path__ + "img/6.aac1bdc2.jpg";